import React from 'react'
import { useRouteMatch, useHistory } from 'react-router-dom'

import PreviewComponent from 'components/Global/Preview'
import useMediaPath from 'hooks/useMediaPath'
interface Props {
  data: { name: string; id: string; logo: string }[]
}
const Materials = ({ data }: Props) => {
  let { url } = useRouteMatch()
  const history = useHistory()

  const mediaPath = useMediaPath()

  const updateUrl = (link: string) => {
    history.push(link)
  }

  return (
    <div>
      {data &&
        data.map((cat, i) => (
          <PreviewComponent
            key={i}
            title={cat.name}
            preview={mediaPath(cat.logo) || ''}
            componentType="thumbnail"
            previewSize={[80, 80]}
            onClickFn={() => {
              updateUrl(`${url}/${cat.id}`)
            }}
            previewSvgColor="light"
          />
        ))}
    </div>
  )
}

export default Materials
